import { useState } from 'react';
import Tick from './../assets/circleTick.png';

type Props = {
    tipo: string;
}

function CardPricing({ tipo }: Props) {
    const [hoveredCard, setHoveredCard] = useState<string | null>(null);

    const ox = ['1 Master Admin'];
    const ox1 = ['1 Master Admin', '1 Manager Admins', '30 Events per year', '5 Assets per event', '8 Reporters per event'];
    const ox2 = ['2 Master Admin', '4 Manager Admins', '100 Events per year', '10 Assets per event', 'Unlimited Reporters'];
    const xoplus = ['4 Master Admin', '10 Manager Admins', 'Unlimited Events', 'Unlimited Assets', 'Unlimited Reporters'];

    const isHovered = hoveredCard === tipo;
    const isDimmed = hoveredCard !== tipo;
    
    return (
        <div 
            onMouseEnter={() => setHoveredCard(tipo)}
            onMouseLeave={() => setHoveredCard(null)}
            className={`transition-all duration-300 border-white border-[1px] h-fit rounded-lg mt-4 
                        ${tipo === 'OX' && hoveredCard === 'OX' ? "w-[330px] p-12" : ""}
                        ${tipo === 'OX1' && hoveredCard === 'OX1' ? "w-[330px] p-12" : ""}
                        ${tipo === 'OX2' && hoveredCard === 'OX2' ? "w-[330px] p-12" : ""}
                        ${tipo === 'XO+' ? "bg-secondBlack w-[330px] p-12 hover:bg-gray" : "w-[300px] p-5"}
                        `}>
            <div className='flex justify-between items-center'>
                <span className="font-bold text-xl text-gray30">{tipo === 'OX' ? "OX Plan" : tipo === 'OX1' ? "OX1 Plan" : tipo === 'OX2' ? "OX2 Plan" : "XO+ Plan"}</span>
                {tipo === 'XO+' && <span className='rounded h-fit bg-grayText p-1 text-black font-bold text-[10px]'>POPULAR</span>}
            </div>
            <span className="flex mt-2 inline-block align-baseline font-regular text-sm text-gray30">{tipo === 'OX' ? "Lorem ipsum" : tipo === 'OX1' ? "Perfect for small teams managing fewer events." : tipo === 'OX2' ? "Lorem ipsum" : "Ideal for large agencies managing multiple events and assets."}</span>
            <div className="flex flex-row items-center mb-4">
                {tipo === 'OX' ? <span className="font-bold text-[50px] text-white">Free</span> 
                : <div className="flex flex-row">
                    <span className="font-bold text-[50px] text-white">${tipo === 'OX1' ? "29" : tipo === 'OX2' ? "149" : "499"}</span>
                    <span className="font-bold text-[30px] text-white self-end pb-2">{tipo === 'OX1' ? ".99" : ".99"}</span>
                </div>}
                {tipo === 'OX' ? <></> 
                : <div className="flex flex-col ml-2">
                    <span className="font-regular text-[10px] text-gray30">per company</span>
                    <span className="font-regular text-[10px] text-gray30">per month</span>
                </div>}
            </div>
            <button className="bg-neonGreen w-full rounded-md py-2 font-bold text-black text-base">
                Get started
            </button>
            <div className="bg-white h-[1px] my-8"></div>
            <span className="flex mb-3 font-bold text-gray30 text-sm">FEATURES</span>
            {tipo === 'OX' ? ox.map((features) => (
                <div className='flex flex-row items-center py-1'>
                    <img src={Tick} className='size-[15px]' />
                    <span className='font-regular text-gray30 ml-2 text-xs'>{features}</span>
                </div>
            )) : tipo === 'OX1' ? ox1.map((features) => (
                <div className='flex flex-row items-center py-1'>
                    <img src={Tick} className='size-[15px]' />
                    <span className='font-regular text-gray30 ml-2 text-xs'>{features}</span>
                </div>
            )) : tipo === 'OX2' ? ox2.map((features) => (
                <div className='flex flex-row items-center py-1'>
                    <img src={Tick} className='size-[15px]' />
                    <span className='font-regular text-gray30 ml-2 text-xs'>{features}</span>
                </div>
            ))
            : xoplus.map((features) => (
                <div className='flex flex-row items-center py-1'>
                    <img src={Tick} className='size-[15px]' />
                    <span className='font-regular text-gray30 ml-2 text-xs'>{features}</span>
                </div>
            ))}
        </div>
    )
}

export default CardPricing